import PropTypes from 'prop-types';
import React from 'react';

const SiteMapSubCategories = ({ subCategories, renderItem, className }) => (
  <ul className={className}>
    {subCategories.map((subCategory) => renderItem(subCategory))}
  </ul>
);

SiteMapSubCategories.propTypes = {
  subCategories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.string.isRequired,
      url: PropTypes.string,
      name: PropTypes.string.isRequired,
      newWindow: PropTypes.bool,
    }),
  ).isRequired,
  renderItem: PropTypes.func.isRequired,
  className: PropTypes.string.isRequired,
};

export default SiteMapSubCategories;
